module.exports = __webpack_public_path__ + "static/media/icons-bundle.307c38c4.svg";